/*
 * @Description:
 * @Author: Xyyyyyy
 * @Date: 2023-06-26 14:16:13
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-06-30 18:47:41
 */
import axios from 'axios'

import { warningPrompt, errorPrompt } from '../utils/promptInfo'
import { backToLogin } from '../utils/login.js'

// 创建HTTP实例
const $http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
})

// 响应拦截
$http.interceptors.response.use((response) => {
  return response.data
}, (error) => {})
export default $http
